import { Button, Card, Drawer, Form, Icons, Input, Select, Typography } from '@pankod/refine-antd';
import { useEffect } from 'react';

export type VariantAttribute = {
  name: string;
  options: string[];
};

export const VariantAttributeConfigDrawer = ({
  open,
  attributes,
  onClose,
  onSave,
}: {
  open: boolean;
  attributes: VariantAttribute[];
  onClose: () => void;
  onSave: (attributes: VariantAttribute[]) => void;
}) => {
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      attributes,
    });
  }, [attributes, form]);

  const handleClose = () => {
    onClose();
    form.submit();
  };

  return (
    <Drawer
      title="Variant Attributes"
      placement="right"
      onClose={handleClose}
      visible={open}
      footer={
        <Button type="primary" onClick={() => form.submit()} style={{ width: '100%' }}>
          Save
        </Button>
      }
    >
      <Form
        form={form}
        layout="vertical"
        scrollToFirstError
        onFinish={(values) => {
          const { attributes } = values;
          onSave(attributes ?? []);
        }}
      >
        <Form.List name="attributes">
          {(fields, { add, remove }) => {
            // @ts-ignore
            // fields = fields.length === 0 ? [{}] : fields;

            return (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {fields.map((field, index) => (
                  <Card
                    key={field.key}
                    title={
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <Typography.Text>Attribute {index + 1}</Typography.Text>
                        <Button
                          type="text"
                          onClick={() => remove(field.name)}
                          icon={<Icons.MinusCircleOutlined />}
                        />
                      </div>
                    }
                  >
                    <Form.Item
                      name={[index, 'name']}
                      label="Name"
                      rules={[{ required: true, message: 'Attribute name is required.' }]}
                    >
                      <Input placeholder="Attribute name" />
                    </Form.Item>

                    <Form.Item
                      name={[index, 'options']}
                      label="Options"
                      rules={[{ required: true, message: 'Please add at least one option.' }]}
                    >
                      <Select mode="tags" options={[]} placeholder="Input your options" />
                    </Form.Item>
                  </Card>
                ))}

                <Form.Item style={{ marginTop: '1rem' }}>
                  <Button type="dashed" onClick={() => add()} style={{ width: '100%' }}>
                    <Icons.PlusOutlined /> Add field
                  </Button>
                </Form.Item>
              </div>
            );
          }}
        </Form.List>
      </Form>
    </Drawer>
  );
};
